module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Impresszum",
	"footer.privacy.url": "https://www.grohe.hu/hu_hu/company/privacy.html",
	"footer.disclaimer.text": "Jogi információk",
	"footer.disclaimer.url": "https://www.grohe.hu/hu_hu/company/legal-info.html",
	"footer.copyright": "&copy; 2017 Grohe Hungary Kft.",
	"homepage.headline": "GROHE Zuhanyrendszer Konfigurátor",
	"homepage.introtext": "Az alábbi kérdőív kitöltésével segítünk az Önhöz leginkább illő GROHE Smartcontrol zuhanyrendszer összeállításában.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Az oldal nem található",
	"404.link.goBack": "Vissza a címlapra",
	"configurator.button.seeResults": "Eredmények megtekintése",
	"question1.question": "Fürdőkádhoz vagy zuhanykabinhoz szerezne be zuhanyrendszert?",
	"question1.option1.text": "Zuhanykabinhoz",
	"question1.option2.text": "Fürdőkádhoz",
	"question2.question": "Válassza ki a kívánt kialakítást!",
	"question2.option1.text": "Felsík előtti kialakítás",
	"question2.option2.text": "Falsík előtti kialakítás a csaptelepre és falsík mögötti a zuhany további elemeire",
	"question2.option3.text": "Falsík mögötti kialakítás",
	"question3.question": "Hogyan szeretné működtetni zuhanyrendszerét?",
	"question3.option1.text": "Termosztátos módon, SmartControl vezéléssel",
	"question3.option2.text": "Hagyományos termosztátos módon",
	"question3.option3.text": "Egykaros keverővel",
	"question3.option4.text": "Diverteres rendszerrel, a meglévő kádcsaptelepem megtartásával",
	"question4.question": "Milyen felszereltségű zuhanyrendszert választana?",
	"question4.option1.text": "Csak kézizuhanyos kivitelt",
	"question4.option2.text": "Nagy fejzuhanyt (150-250mm) és kézizuhanyt",
	"question4.option3.text": "Óriási fejzuhanyt (250-400mm) és kézizuhanyt",
	"question4.option4.text": "Nagy fejzuhanyt (150-250mm) és kézizuhanyt",
	"question4.option5.text": "Óriási fejzuhanyt (250-400mm) és kézizuhanyt",
	"question5.question": "Válassza ki a kívánt formát!",
	"question5.option1.text": "Szögletes",
	"question5.option2.text": "Lekerekített",
	"question6.question": "Hány víz kimenettel számolhatunk?",
	"question6.option1.text": "Három víz kimenet: Fejzuhany normál és masszás funkcióval, illetve kézizuhany",
	"question6.option2.text": "Három víz kimenet: Kétfunkciós fejzuhany és kézizuhany",
	"question6.option3.text": "Három víz kimenet: Fejzuhany, kézizuhany és kádtöltő",
	"question6.option4.text": "Három víz kimenet: Fejzuhany, kézizuhany és oldalsó szórófej",
	"question6.option5.text": "Kettő víz kimenet: Fejzuhany és kézizuhany",
	"question6.option6.text": "Kettő víz kimenet: Kézizuhany és kádtöltő",
	"question6.option7.text": "Egyetlen víz kimenet: Kizárólag kézizuhany",
	"question6.option8.text": "Egyetlen víz kimenet: Kádtöltő",
	"question7.question": "Válassza ki a kívánt színt!",
	"question7.option1.text": "Króm",
	"question7.option2.text": "Fehér / króm",
	"question7.option3.text": "Fehér / króm",
	"question8.question": "Szeretné a szetthez tartozó kézizuhany tartót választani?",
	"question8.option1.text": "Nem, más kézizuhany tartót választok",
	"question8.option2.text": "Igen",
	"question9.question": "Kérjük, válasszon a  zuhanysínes vagy a fix falitartós kézizuhany szettek közül!",
	"question9.option1.text": "Zuhanysínes kézizuhany szett",
	"question9.option2.text": "Fix falitartós kézizuhany szett",
	"question10.question": "Kérjük, válasszon a fali vagy mennyezeti fejzuhany kivitelek között!",
	"question10.option1.text": "Fali fejzuhany",
	"question10.option2.text": "Mennyezeti fejzuhany",
	"results.title": "Your {productGroupsCount, plural, \none {Eredmény} \nother {Eredmény}\n}",
	"results.proposal.title": "Ajánlatunk {number}",
	"results.proposal.title.single": "Ajánlatunk",
	"results.bundle.title": "A helyes beszereléshez, az alábbi kellékekre is szükség lesz:",
	"results.newConfiguration.title": "Szeretné újrakezdeni a zuhanykonfigurátort?",
	"results.newConfiguration.buttonText": "Elölről kezdem",
	"results.product.number": "Cikkszám: #{number}",
	"results.product.button.productInformation": "Termékleírás",
	"results.product.button.dealerLocator": "Bemutatóterem keresése",
	"results.product.button.buyNow": "Online vásárlás",
	"results.product.button.downloadPDF": "Ajánlatok letöltése(PDF)",
	"results.product.information": "Termékleírás",
	"results.product.dealer": "Bemutatóterem keresése",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.hu_hu.json
// module id = 751
// module chunks = 0